import React from 'react';
import SEO from '../components/SEO';

const CancellationPolicy = () => {
    return (
        <div className="bg-white text-black min-h-screen p-8 mt-12">
            <SEO
                title="Cancellation Policy - Hive Workspaces"
                description="Read Hive Workspaces cancellation policy. Learn about our terms for cancelling bookings and rescheduling services."
                canonical="/cancellation-policy"
            />
            <div className="max-w-4xl mx-auto">
                <h1 className="text-4xl font-bold text-center mb-4 text-gray-800 uppercase">
                    CANCELLATION POLICY
                </h1>
                <p className="text-center text-gray-600 mb-8 italic">Last Updated: 26-02-2026</p>

                <div className="space-y-8">
                    <section className="pb-4">
                        <p className="text-gray-800 leading-relaxed">
                            At Hive Workspaces, we strive to provide flexible workspace solutions. This Cancellation Policy explains how customers can cancel their bookings or services.
                        </p>
                    </section>

                    <section className="border-b border-gray-200 pb-6">
                        <h2 className="text-2xl font-semibold mb-4 text-gray-700">1. Cancellation Requests</h2>
                        <div className="text-gray-800 leading-relaxed">
                            <p>
                                Customers may cancel their meeting room, workspace, or service bookings by contacting us through our official website, registered email, or authorised contact channels. Cancellation requests must be submitted before the scheduled booking start time.
                            </p>
                        </div>
                    </section>

                    <section className="border-b border-gray-200 pb-6">
                        <h2 className="text-2xl font-semibold mb-4 text-gray-700">2. Cancellation Timeline</h2>
                        <div className="text-gray-800 leading-relaxed">
                            <ul className="list-disc ml-6 space-y-2">
                                <li>Cancellations made at least <strong>24 hours</strong> before the scheduled booking time may be eligible for a full refund or rescheduling.</li>
                                <li>Cancellations made less than <strong>24 hours</strong> before the booking time may be subject to partial charges.</li>
                                <li>No refunds will be provided for no-shows or cancellations made after the booking has started.</li>
                            </ul>
                        </div>
                    </section>

                    <section className="border-b border-gray-200 pb-6">
                        <h2 className="text-2xl font-semibold mb-4 text-gray-700">3. Rescheduling</h2>
                        <div className="text-gray-800 leading-relaxed">
                            <p>
                                Customers may request to reschedule bookings based on availability. Hive Workspaces reserves the right to approve or decline rescheduling requests.
                            </p>
                        </div>
                    </section>

                    <section className="border-b border-gray-200 pb-6">
                        <h2 className="text-2xl font-semibold mb-4 text-gray-700">4. Service Cancellation by Hive Workspaces</h2>
                        <div className="text-gray-800 leading-relaxed">
                            <p>
                                In rare situations where Hive Workspaces must cancel a confirmed booking due to operational or unforeseen circumstances, customers will be offered an alternative slot or a full refund.
                            </p>
                        </div>
                    </section>

                    <section className="pb-8">
                        <h2 className="text-2xl font-semibold mb-4 text-gray-700">5. Contact Us</h2>
                        <div className="text-gray-800 leading-relaxed space-y-2">
                            <p>For cancellation requests or assistance, please contact:</p>
                            <div className="mt-4">
                                <p className="font-semibold">Hive Workspaces</p>
                                <p>Website: <a href="https://www.hiveworkspaces.com" className="text-blue-600 hover:underline">https://www.hiveworkspaces.com</a></p>
                                <p>Email: <a href="mailto:hello@hiveworkspaces.com" className="text-blue-600 hover:underline">hello@hiveworkspaces.com</a></p>
                                <p>Phone/WhatsApp: +91 7022274000</p>
                            </div>
                        </div>
                    </section>

                    <section className="pt-4 border-t border-gray-200 italic text-gray-600">
                        <p>By using our services or making a booking, you agree to this Cancellation Policy.</p>
                    </section>
                </div>
            </div>
        </div>
    );
};

export default CancellationPolicy;
